import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Outlet } from 'react-router-dom';

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary.js';
import { ToolkitGenericFallback } from '../../components/ToolkitGenericFallback.js';
import { useFeatureClientReadyState } from '../../featureDecisions/index.js';
import { whatEnv } from '../../utils/whatEnv.js';
import { FTUXContextProvider } from '../FTUXContextProvider.js';
import { ModuleContextProvider } from '../ModuleContextProvider.js';

export function RootRouteElement() {
  const isLocal = whatEnv() === 'local';

  const isFeatureClientReady = useFeatureClientReadyState();
  if (!isFeatureClientReady) {
    return null;
  }

  return (
    <ModuleContextProvider expectOrder={false}>
      <FTUXContextProvider>
        <ErrorBoundary Fallback={ToolkitGenericFallback}>
          <Outlet />
        </ErrorBoundary>
        {isLocal && <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />}
      </FTUXContextProvider>
    </ModuleContextProvider>
  );
}
